import { Box, Container } from '@mui/material'
import React from 'react'

type MainProps = {
  children: React.ReactNode
  /**
   * Drops the space above the page. For a page that heads itself with the DS PageHeader, whose
   * own padding is the space the Figma frames show under the app bar.
   */
  flushTop?: boolean
  /** Gutters the page on the DS `Spacing/container-padding` (24px) rather than the app's 16px. */
  wideGutters?: boolean
}

export const Main = (props: MainProps): JSX.Element => {
  const { children, flushTop = false, wideGutters = false } = props
  // Container gutters itself at 16px, then 24px from `sm` up. Naming both breakpoints is what
  // holds the chosen figure across the whole range; a bare `px` loses to that `sm` rule.
  const gutter = wideGutters ? 3 : 2

  return (
    <Box component="main" sx={{ flexGrow: 1, pt: flushTop ? 0 : 8, pb: 8 }}>
      <Container
        maxWidth={false}
        sx={{
          px: { xs: gutter, sm: gutter },
          position: 'relative',
          minHeight: 'calc(100vh - 110px)',
          display: 'flex',
          flexDirection: 'column',
        }}>
        {children}
      </Container>
    </Box>
  )
}
